import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const NotificationCenterApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "NotificationCenter" */ "./NotificationCenterApp");
    return { default: namedExport.NotificationCenterApp };
});

export const NotificationCenter: TeamAppConfig = {
    title: "Notification Center",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "A centralized place to view and manage your notifications and actions.",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: NotificationCenterApp,
    path: "/NotificationCenter"
};
